<template>
  <div class="page-container">
    <el-form ref="propsParams" :rules="ruleValidate" :model="propsParams" label-width="100px">
      <div class="top-layout">
        <div class="left-panel">
          <!-- 左侧表单内容：卡源、资费类型、总流量... -->
          <!-- <el-form-item label="卡源" prop="channel">
            <el-select v-model="propsParams.channel" placeholder="请选择卡源" @change="handleSelectChannel">
              <el-option
                v-for="item in channels"
                :key="item.channel"
                :label="item.name"
                :value="item.channel"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="资费类型" prop="productType">
            <el-select v-model="propsParams.productType" placeholder="请选择资费类型">
              <el-option
                v-for="item in optType"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="外部套餐ID" prop="externalProductId" v-if="propsParams.channel == 'cmlink' && propsParams.productType == '2'">
            <el-select v-model="propsParams.externalProductId" filterable clearable placeholder="请选择外部套餐ID">
              <el-option
                v-for="item in productExternalData"
                :key="item.productId"
                :label="item.name + '[' + item.productId + ']'"
                :value="item.productId"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="资费名" prop="productName">
            <el-input v-model="propsParams.productName" placeholder="资费"></el-input>
          </el-form-item>
          <el-form-item label="总流量" prop="flowCount">
            <el-input placeholder="请输入总流量单位MB" v-model="propsParams.flowCount">
              <template slot="append">MB</template>
            </el-input>
          </el-form-item>
          <el-form-item label="展示总流量" prop="showFlowCount">
            <el-input placeholder="请输入展示总流量单位MB" v-model="propsParams.showFlowCount">
              <template slot="append">MB</template>
            </el-input>
          </el-form-item>
          <el-form-item label="有效期" prop="validityTime">
            <el-input placeholder="有效期，30天为一月" v-model="propsParams.validityTime">
              <template slot="append">天</template>
            </el-input>
          </el-form-item>
          <el-form-item label="市场价格" prop="showPrice">
            <el-input placeholder="市场价格" v-model="propsParams.showPrice" >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="描述信息" prop="remark" >
            <el-input
              style="width:355px;"
              type="textarea"
              :rows="3"
              placeholder="请输入列表描述信息"
              v-model="propsParams.remark"
            ></el-input>
          </el-form-item>
          
        </div>
        <div class="right-panel">
          <el-form-item label="资费" prop="flowInfo">
            <el-checkbox-group v-model="propsParams.flowInfo">
              <el-checkbox v-for="item in flowInfos" :label="item.value" :key="item.value">{{item.label}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="状态设置" prop="status">
            <div style="display: flex; gap: 40px; align-items: center;">
              <div style="display: flex; align-items: center;">
                <span style="margin-right: 10px;">是否启用</span>
                <el-switch v-model="propsParams.status" :active-value="1" :inactive-value="0" active-color="#13ce66"></el-switch>
              </div>
              <div style="display: flex; align-items: center;">
                <span style="margin-right: 10px;">国际站展示</span>
                <el-switch v-model="propsParams.website" :active-value="1" :inactive-value="0" active-color="#13ce66"></el-switch>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="语音" prop="voiceTotal">
            <el-input v-model="propsParams.voiceTotal" >
                <template slot="append">分钟</template>
            </el-input>
          </el-form-item>
          <el-form-item label="短信(MO)" prop="smsMo">
            <el-input v-model="propsParams.smsMo" >
                <template slot="append">条</template>
            </el-input>
          </el-form-item>
          <el-form-item label="短信(MT)" prop="smsMt">
            <el-input v-model="propsParams.smsMt" >
                <template slot="append">条</template>
            </el-input>
          </el-form-item>
        </div>
      </div>
      <div class="submit-footer">
        <el-button class="submit-btn" type="primary"  @click="handleSubmit">提交</el-button>
      </div>
    </el-form>
  
  </div>
</template>
<script>
import { addInternationalProduct , productExternalList} from "@/api/international.js";
import { listChannel } from "@/api/api.js";
export default {
  name: "internationalProductAdd",
  data() {
    let validateOperator = (rule, value, callback) => {
      let scs = this.propsParams.countryPrices
      if(scs.length == 0){
        callback(new Error('请配置套餐售卖国家价格'));
      }else{
        callback();
      }
    }
    return {
      internationalPrice:"",
      propsParams: {
        type:"3",
        productType:1,
        status:1,
        website:'0',
        countryPrice:[],
        channel:'multi',
        countryPrices:[],
        flowInfo:[],
      },
      optType: [{ value: "累计套餐", key: 1 },{ value: "月套餐", key: 2 },{ value: "加油包", key: 3 }],
      optNetwork: [
        { value: 2, label: "2G" },
        { value: 3, label: "3G" },
        { value: 4, label: "4G" },
        { value: 5, label: "5G" }
      ],
      flowInfos: [
        {value: "1", label: "推荐"},
        {value: "7", label: "不限速"},
        {value: "8", label: "热卖"},
      ],
      channels:[],
      ruleValidate: {
        productName: [
          { required: true, message: "请输入资费名", trigger: "blur" },
          { min: 3,max: 100,message: "请输入3至100字母数字或汉字",trigger: "blur"},
        ],
        type: [
          { required: true, message: "请选择套餐分类", trigger: "blur" }
        ],
        operator:[{ validator: validateOperator, required: true, trigger: "blur" }],
        productType: [
          { required: true, message: "请选择资费类型", trigger: "blur" }
        ],
        flowRatio: [
          { required: true, message: "请输入流量比例", trigger: "blur" }
        ],
        flowCount: [
          { required: true, message: "请输入总流量", trigger: "blur" },
          { 
            pattern: /^[1-9]\d*(\.\d{1,2})?$|^0\.\d{1,2}$/,
            message: '请输入大于0的数字，最多保留两位小数',
            trigger: ['blur', 'change'] 
          }
        ],
        showFlowCount: [
          { required: true, message: "请输入展示总流量", trigger: "blur" },
          { 
            pattern: /^[1-9]\d*(\.\d{1,2})?$|^0\.\d{1,2}$/,
            message: '请输入大于0的数字，最多保留两位小数',
            trigger: ['blur', 'change'] 
          }
        ],
        validityTime: [
          { required: true, message: "请输入有效期", trigger: "blur" }
        ],
        floorPrice: [
          { required: true, message: "请输入价格", trigger: "blur" }
        ],
        showPrice: [
          { required: true, message: "请输入市场价格", trigger: "blur" }
        ],
        remark:[
          { required: true, message: "请输入描述信息", trigger: "blur" }
        ],
        externalProductId:[
          {required: true, message: "请选择运营商套餐", trigger: "blur"}
        ]
      },
      productExternalData:[],
    };
  },
  methods: {
    initChannel(){
      let operatorId = '4'
      listChannel({operatorId}).then(res=>{
        this.channels = res.data.data
      })
    },
    // 创建套餐
    handleSubmit() {
      let params = {
        ...this.propsParams,
      };
      this.$refs.propsParams.validate(valid => {
        if (valid) {
          addInternationalProduct(params).then(res => {
            this.$message.success("添加套餐成功");
            this.$store.dispatch('tagsView/delView', this.$route)
            this.$router.push({ path: `/package/internationalProduct` });
          });
        }
      });
    },
    
    handleSelectChannel(channel){
      this.propsParams.countryPrices = []
    },
    
    selectProductExternalList(){
      let source = '2'
      productExternalList({source}).then(res=>{
        this.productExternalData = res.data.data
      })
    },
  },
  mounted() {

  },
  created() {
    // this.selectProductExternalList()
    // this.initChannel()
  }
};
</script>
<style scoped lang="less">
.page-container {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 90vh; /* 确保占满浏览器可视区域 */
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  .top-layout {
    flex: 0 0 30%; 
    display: flex;
    overflow: hidden; 
    // border-bottom: 1px solid #eee; 
  }
  // 左侧部分
  .left-panel {
    width: 50%; /* 左右各占一半 */
    overflow-y: auto;
    padding: 20px 20px 0 20px;
    box-sizing: border-box;
    // border-right: 1px solid #eee; 
  }
  //右侧部分
  .right-panel {
    width: 50%;
    overflow-y: auto;
    padding: 20px 20px 0 20px;
    box-sizing: border-box;
  }
  .submit-footer {
    position: absolute;  
    bottom: 0;           
    left: 0;             
    width: 100%;         
    padding: 20px;       
    box-sizing: border-box; 
    z-index: 99;
  }

}

::v-deep .hide-checkbox .cell .el-checkbox__input {
  display: none !important;
}
.el-select {
  width: 350px;
  margin-left: 5px;
}
.el-input {
  width: 350px;
  margin-left: 5px;
}
.el-button {
  margin-left: 5px;
  border-radius: 3px;
  padding: 10px 20px;
}
.cell button {
  width: 50px;
  font-size: 12px;
  text-align: center;
  padding: 6px;
}
.el-message-box__btns .el-button--small {
  width: 75px;
}

</style>
